import { render, staticRenderFns } from "./project-activity-items.vue?vue&type=template&id=3b462aaa&scoped=true&"
import script from "./project-activity-items.vue?vue&type=script&lang=js&"
export * from "./project-activity-items.vue?vue&type=script&lang=js&"
import style0 from "./project-activity-items.vue?vue&type=style&index=0&id=3b462aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b462aaa",
  null
  
)

export default component.exports